var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H94V94H0V0Z",
    fill: "#F7DF1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7162 78.5531L31.9094 74.1998C33.2974 76.6603 34.5598 78.7422 37.5879 78.7422C40.4906 78.7422 42.321 77.6069 42.321 73.1904V43.1552H51.1544V73.3152C51.1544 82.4644 45.7913 86.629 37.9665 86.629C30.9 86.629 26.7981 82.9693 24.7158 78.5524L24.7162 78.5531ZM55.9525 77.6065L63.1449 73.4422C65.0385 76.5343 67.4994 78.8058 71.8528 78.8058C75.5133 78.8058 77.8471 76.9757 77.8471 74.4516C77.8471 71.4231 75.4494 70.3502 71.4111 68.584L69.2032 67.6366C62.8299 64.9242 58.6025 61.5167 58.6025 54.3235C58.6025 47.698 63.6502 42.6499 71.5377 42.6499C77.1535 42.6499 81.1918 44.6063 84.0941 49.7172L77.2159 54.1344C75.7013 51.4213 74.0614 50.3487 71.5374 50.3487C68.9502 50.3487 67.3096 51.9893 67.3096 54.1344C67.3096 56.7844 68.9502 57.8577 72.7359 59.4983L74.9441 60.4445C82.4531 63.6629 86.6805 66.9438 86.6805 74.3257C86.6805 82.2768 80.434 86.6302 72.0419 86.6302C63.8393 86.6302 58.5389 82.7181 55.9521 77.6069",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJsIcon);
export default __webpack_public_path__ + "static/media/js-icon.db57419c8b71110ac0e279bf2c579945.svg";
export { ForwardRef as ReactComponent };